import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import SideBar from "../../other/SideBar";
import NavBar from "../../other/NavBar";
import LoadingModal from "../../../loader/LoadingModal";
import {
  CreateInvoiceURL,
  GetSupplierAndRawMaterialListURL,

} from "../../../assets/api/BaseURL";
import Notification from "../../other/Notification";
import { useToast } from "../../../../context/ToastContext";

const CreatePurchase = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [token, setToken] = useState("");
  const [toggleSideBar, setToggleSideBar] = useState(false);
  const [canvas, setCanvas] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [flag, setFlag] = useState(false);
  const [suppliersList, setSuppliersList] = useState([]);
  const [rawMaterialsList, setRawMaterialsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [formData, setFormData] = useState({
    invoiceNumber: "",
    invoiceDate: getToday(),
    dueDate: getToday(),
    supplier: "",
    referenceNumber: "",
    note: "",
    items: [],
    subtotal: "",
    tax: "",
    total: "",
    // openingStock:0
  });
  const [productData, setProductData] = useState({
    productId: "",
    productName: "",
    quantity: "1",
    purchasePrice: "",
    expiryDate: "",
    basePrice: "",
    discount: "",
    taxable: "",
    taxableValue: "",
    tax: "",
    taxAmount: "",
    amount: "",
    closingStock: "",
    measurement_unit: ""
  });

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    setToggleSideBar(!toggleSideBar);
  };

  const handleToggleOffCanvas = (e) => {
    e.preventDefault();
    setCanvas(!canvas);
  };

  const handleBackClick = (e) => {
    e.preventDefault();
    navigate("/view_purchase");
  };

  function getToday() {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1;
    let dd = today.getDate();

    if (mm < 10) mm = "0" + mm;
    if (dd < 10) dd = "0" + dd;

    return `${yyyy}-${mm}-${dd}`;
  }

  function convertDateFormat(inputDate) {
    if (!inputDate || inputDate.trim() === "") {
      return "";
    }

    const parts = inputDate.split("-");
    const outputDate = parts[2] + "-" + parts[1] + "-" + parts[0];

    return outputDate;
  }

  const isValidNumber = (value) => {
    return !isNaN(parseFloat(value)) && isFinite(value);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError("");
    setSuccess("");
  };

  const handleProductInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "productId") {
      if (value === "") {
        setProductData((prevData) => ({
          ...prevData,
          productId: "",
          productName: "",
          purchasePrice: "",
          quantity: "1",
          amount: "",
          closingStock: "",
          measurement_unit: ""
        }));
      } else {
        const selectedProduct = rawMaterialsList.find(
          (item) => item.id === parseInt(value)
        );

        if (selectedProduct) {
          const quantity = productData.quantity;
          const purchasePrice = selectedProduct.purchase_price;
          const amount = parseFloat(quantity) * parseFloat(purchasePrice);

          setProductData((prevData) => ({
            ...prevData,
            productId: value,
            productName: selectedProduct.material_name,
            purchasePrice: selectedProduct.purchase_price,
            closingStock: selectedProduct.closing_stock,
            measurement_unit: selectedProduct.measurement_unit,
            amount: isNaN(amount) ? "" : amount.toFixed(2),
          }));
        }
      }
    } else if (name === "quantity" || name === "purchasePrice") {
      const quantity = name === "quantity" ? value : productData.quantity;
      const purchasePrice =
        name === "purchasePrice" ? value : productData.purchasePrice;
      const amount = parseFloat(quantity) * parseFloat(purchasePrice);

      setProductData((prevData) => ({
        ...prevData,
        [name]: value,
        amount: isNaN(amount) ? "" : amount.toFixed(2),
      }));
    } else {
      setProductData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    setError("");
    setSuccess("");
  };

  const handleDelete = (index) => {
    const updatedItems = [...formData.items];
    updatedItems.splice(index, 1);
    setFormData({ ...formData, items: updatedItems });
  };

  const handleAddProductClick = () => {
    if (productData.productId === "") {
      setError("Ingredient cannot be empty");
      setSuccess("");
    } else if (
      formData.items.some((item) => item.productId === productData.productId)
    ) {
      setError("The same Ingredient has already been added");
      setSuccess("");
    } else if (productData.quantity === "") {
      setError("Quantity cannot be empty");
      setSuccess("");
    } else if (!isValidNumber(productData.quantity)) {
      setError("Please enter a valid Quantity");
      setSuccess("");
    } else if (productData.purchasePrice === "") {
      setError("Purchase Price cannot be empty");
      setSuccess("");
    } else if (!isValidNumber(productData.purchasePrice)) {
      setError("Please enter a valid Purchase Price");
      setSuccess("");
    }


    // else if (productData.expiryDate === "") {
    //   setError("Expiry Date cannot be empty");
    //   setSuccess("");
    // }
    else {
      setFormData((prevData) => ({
        ...prevData,
        items: [...prevData.items, productData],
      }));
      setProductData({
        productId: "",
        productName: "",
        quantity: "1",
        purchasePrice: "",
        expiryDate: "",
        basePrice: "",
        discount: "",
        taxable: "",
        taxableValue: "",
        tax: "",
        taxAmount: "",
        amount: "",
        closingStock: "",
        measurement_unit: "",
      });
    }
  };

  const handleCreateInvoice = async () => {
    // if(formData.openingStock === '')
    // console.log(formData.openingStock)
    if (formData.invoiceNumber === "" || formData.invoiceNumber.trim() === "") {
      setError("Purchase Number cannot be empty");
      setSuccess("");
    } else if (formData.invoiceDate === "") {
      setError("Purchase order Date cannot be empty");
      setSuccess("");
    } else if (formData.dueDate === "") {
      setError("Due Date cannot be empty");
      setSuccess("");
    } else if (new Date(formData.dueDate) < new Date(formData.invoiceDate)) {
      setError("Due Date cannot be before Purchase order Date");
      setSuccess("");
    } else if (formData.supplier === "") {
      setError("Please select supplier");
      setSuccess("");
    } else if (formData.items.length === 0) {
      setError("Please add atleast one product to create invoice");
      setSuccess("");
    }
    else {


      try {
        const response = await axios({
          method: "post",
          url: CreateInvoiceURL,
          data: formData,
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200 && response.data.message) {
          setError("");
          setSuccess(response.data.message);
          setFormData({
            invoiceNumber: "",
            invoiceDate: getToday(),
            dueDate: getToday(),
            supplier: "",
            referenceNumber: "",
            note: "",
            items: [],
            subtotal: "",
            tax: "",
            total: "",
          });
          setFlag(!flag);
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          setError(error.response.data.message);
          setSuccess("");
        } else {
          setError(error.message);
          setSuccess("");
        }
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/auth");
    }
  }, [navigate]);

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, [token]);


  useEffect(() => {
    if (localStorage.getItem("currencySymbol")) {
      setCurrencySymbol(localStorage.getItem("currencySymbol"));
    }
  }, []);

  useEffect(() => {
    if (token) {
      async function getData() {
        setIsLoading(true);
        try {
          const response = await axios.get(GetSupplierAndRawMaterialListURL, {
            headers: { authorization: `Bearer ${token}` },
          });

          if (response.status === 200 && response.data) {
            setSuppliersList(
              response.data.supplierList
                ? response.data.supplierList.filter((item) => item.status === 1)
                : []
            );
            setRawMaterialsList(
              response.data.rawMaterialsList
                ? response.data.rawMaterialsList
                : []
            );
            setFormData((prevData) => ({
              ...prevData,
              invoiceNumber: response.data.invoiceNumber
                ? response.data.invoiceNumber
                : "",
            }));
          }
        } catch (error) {
          if (error.response && error.response.data.message) {
            addToast("error", error.response.data.message);
          } else {
            addToast("error", error.message);
          }
          console.log(error);
        }
        setIsLoading(false);
      }
      getData();
    }
  }, [token, flag, addToast]);

  useEffect(() => {
    if (error || success) {
      window.scrollTo(0, 0);
    }
  }, [error, success]);

  // useEffect(() => {
  //   if (formData.items) {
  //     const subtotal = formData.items.reduce(
  //       (acc, item) => acc + parseFloat(item.taxableValue),
  //       0
  //     );

  //     const taxTotal = formData.items.reduce(
  //       (acc, item) => acc + parseFloat(item.taxAmount),
  //       0
  //     );

  //     const total = subtotal + taxTotal;

  //     setFormData((prevData) => ({
  //       ...prevData,
  //       subtotal: subtotal,
  //       tax: taxTotal,
  //       total: total,
  //     }));
  //   }
  // }, [formData.items]);

  useEffect(() => {
    if (formData.items) {
      const subtotal = formData.items.reduce(
        (acc, item) => acc + parseFloat(item.amount),
        0
      );

      setFormData((prevData) => ({
        ...prevData,
        total: subtotal,
      }));
    }
  }, [formData.items]);

  return (
    <>
      {token && (
        <>
          <div
            className={
              toggleSideBar
                ? "container-scroller sidebar-icon-only"
                : "container-scroller"
            }
          >
            <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
              <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                <Link className="navbar-brand brand-logo-mini" to="/fooders_cp">
                  {/* <img src="images/mini-kr-logo.svg" alt="logo" />     */}
                </Link>
                <div className="me-1">
                  <button
                    className={
                      toggleSideBar
                        ? "navbar-toggler navbar-toggler align-self-center"
                        : "navbar-toggler navbar-toggler align-self-center text-white"
                    }
                    type="button"
                    onClick={handleToggleSidebar}
                  >
                    <span className="icon-menu"></span>
                  </button>
                </div>
                <div>
                  <Link to="/fooders_cp">
                    <span className="navbar-brand brand-logo">
                      <img src="images/vyfoo_logo.png" alt="logo" />
                    </span>
                  </Link>
                </div>
              </div>
              <NavBar handleToggle={handleToggleOffCanvas} toggleCanvas={toggleSideBar} />
            </nav>
            <div className="container-fluid page-body-wrapper px-0">
              <SideBar active="view_purchase" toggleCanvas={toggleSideBar} />

              <div className="main-panel">
                <div className="content-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div className="vsalign">
                          <h4 className="card-title card-title-dash">
                            Create Purchase
                          </h4>
                        </div>
                        <div className="vsalign">
                          <span
                            className="btn btn-danger mb-0 me-0"
                            onClick={handleBackClick}
                          >
                            <i className="menu-icon mdi mdi-arrow-left vsalign"></i>
                            Go Back
                          </span>
                        </div>
                      </div>
                      <div className="row flex-grow">
                        <div className="col-12 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body">
                              <form className="">
                                {error && (
                                  <div className="d-flex justify-content-between align-items-start alert alert-danger">
                                    <div className="vsalign">{error}</div>
                                    <div className="vsalign">
                                      <span
                                        className=".h3 text-muted"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setError("")}
                                      >
                                        x
                                      </span>
                                    </div>
                                  </div>
                                )}
                                {success && (
                                  <div className="d-flex justify-content-between align-items-start alert alert-success">
                                    <div className="vsalign">{success}</div>
                                    <div className="vsalign">
                                      <span
                                        className=".h3 text-muted"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setSuccess("")}
                                      >
                                        x
                                      </span>
                                    </div>
                                  </div>
                                )}

                                <div className="row">
                                  <div className="col-lg-4 col-md-4">
                                    <div className="form-group">
                                      <label>
                                        Purchase Number
                                        {/* <span className="text-danger">*</span> */}
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name="invoiceNumber"
                                        value={formData.invoiceNumber}
                                        readOnly={true}
                                      // onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                    <div className="form-group">
                                      <label>
                                        Purchase order Date
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        className="form-control"
                                        type="date"
                                        placeholder="Purchase order Date"
                                        name="invoiceDate"
                                        value={formData.invoiceDate}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                    <div className="form-group">
                                      <label>
                                        Due Date
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        className="form-control"
                                        type="date"
                                        placeholder="Due Date"
                                        name="dueDate"
                                        value={formData.dueDate}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                    <div className="form-group">
                                      <label>
                                        Suppliers
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-select"
                                        name="supplier"
                                        value={formData.supplier}
                                        onChange={handleInputChange}
                                      >
                                        <option value="">
                                          Select Supplier
                                        </option>
                                        {suppliersList.map((item) => (
                                          <option key={item.id} value={item.id}>
                                            {item.suppliers_name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                    <div className="form-group">
                                      <label> Reference Number</label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Reference Number"
                                        name="referenceNumber"
                                        value={formData.referenceNumber}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>


                                  {/* <div className="col-lg-4">
                                     
                                    
                                        <div className="form-group">
                                        <label>Add to Stock</label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter Opening Stock"
                                            name="openingStock"
                                            value={formData.openingStock}
                                            onChange={handleInputChange}
                                          />
                                        </div>
                                       
                                  </div> */}




                                  <div className="col-12">
                                    <div className="form-group">
                                      <label>Note</label>
                                      <textarea
                                        className="form-control"
                                        placeholder="Enter Note"
                                        rows="3"
                                        name="note"
                                        value={formData.note}
                                        onChange={handleInputChange}
                                      ></textarea>
                                    </div>
                                  </div>
                                  <hr className="mt-2" />

                                  <div className="table-responsive  mt-1">
                                    <table className="table select-table itemtb">
                                      <thead>
                                        <tr>
                                          <th>Ingredients</th>
                                          <th>
                                            Purchase Price ({currencySymbol})
                                            {/* <br />
                                            (INCL. TAX) */}
                                          </th>
                                          <th>Quantity</th>
                                          <th>Expiry Date</th>
                                          {/* <th>
                                            Base Price
                                            <br />
                                            (RS./ UNIT)
                                          </th>
                                          <th>Discount(%)</th>
                                          <th>
                                            NET TAXABLE <br />
                                            (RS./ UNIT)
                                          </th>
                                          <th>
                                            NET TAXABLE VALUE
                                            <br />
                                            (Total)
                                          </th>
                                          <th style={{ width: "9%" }}>
                                            Tax(GST)
                                          </th>
                                          <th>Tax Amount</th> */}
                                          <th>Amount ({currencySymbol})</th>
                                          <th></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {/* <tr>
                                          <td>
                                            <input
                                              className="form-control"
                                              type="text"
                                              placeholder="Product Name"
                                              name="productName"
                                              value={productData.productName}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            />
                                          </td>
                                          <td>
                                            <input
                                              className="form-control"
                                              type="text"
                                              placeholder=""
                                              name="quantity"
                                              value={productData.quantity}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            />
                                          </td>
                                          <td>
                                            <input
                                              className="form-control"
                                              type="text"
                                              placeholder=""
                                              name="purchasePrice"
                                              value={productData.purchasePrice}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            />
                                          </td>
                                          <td>
                                            <input
                                              className="form-control"
                                              type="text"
                                              placeholder=""
                                              name="basePrice"
                                              value={productData.basePrice}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            />
                                          </td>
                                          <td>
                                            <input
                                              className="form-control"
                                              type="text"
                                              placeholder=""
                                              name="discount"
                                              value={productData.discount}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            />
                                          </td>
                                          <td>
                                            <input
                                              className="form-control"
                                              type="text"
                                              placeholder=""
                                              name="taxable"
                                              value={productData.taxable}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            />
                                          </td>
                                          <td>
                                            <input
                                              className="form-control"
                                              type="text"
                                              placeholder=""
                                              name="taxableValue"
                                              value={productData.taxableValue}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            />
                                          </td>
                                          <td>
                                            <select
                                              className="form-select"
                                              style={{ height: "35px" }}
                                              name="tax"
                                              value={productData.tax}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            >
                                              <option value="">Select</option>
                                              <option value="0">0% GST</option>
                                              <option value="5">5% GST</option>
                                              <option value="12">
                                                12% GST
                                              </option>
                                              <option value="18">
                                                18% GST
                                              </option>
                                              <option value="28">
                                                28% GST
                                              </option>
                                            </select>
                                          </td>
                                          <td>
                                            <input
                                              className="form-control"
                                              type="text"
                                              placeholder=""
                                              name="taxAmount"
                                              value={productData.taxAmount}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            />
                                          </td>
                                          <td>
                                            <input
                                              className="form-control"
                                              type="text"
                                              placeholder=""
                                              name="amount"
                                              value={productData.amount}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            />
                                          </td>
                                          <td>
                                            <button
                                              className="btn btn-primary btn-sm"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                handleAddProductClick();
                                              }}
                                            >
                                              Add
                                            </button>
                                          </td>
                                        </tr> */}

                                        <tr>
                                          <td>
                                            <select
                                              className="form-select"
                                              name="productId"
                                              value={productData.productId}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            >
                                              <option value="">
                                                Select Ingredient
                                              </option>
                                              {rawMaterialsList.map((item) => (
                                                <option
                                                  key={item.id}
                                                  value={item.id}
                                                >
                                                  {item.material_name}
                                                </option>
                                              ))}
                                            </select>
                                            {productData &&
                                              productData.closingStock && (
                                                <label className="stocklb">
                                                  Stock :{" "}
                                                  {parseFloat(productData.closingStock).toFixed(2)}({productData.measurement_unit})
                                                </label>
                                              )}
                                          </td>
                                          <td>
                                            <input
                                              className="form-control"
                                              type="text"
                                              placeholder=""
                                              name="purchasePrice"
                                              value={productData.purchasePrice}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            />
                                          </td>
                                          <td>
                                            <input
                                              className="form-control"
                                              type="text"
                                              placeholder=""
                                              name="quantity"
                                              value={productData.quantity}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            />
                                          </td>
                                          <td>
                                            <input
                                              className="form-control"
                                              type="date"
                                              placeholder=""
                                              name="expiryDate"
                                              value={productData.expiryDate}
                                              onChange={
                                                handleProductInputChange
                                              }
                                            />
                                          </td>
                                          <td>
                                            <input
                                              className="form-control"
                                              type="text"
                                              placeholder=""
                                              name="amount"
                                              value={productData.amount}
                                              readOnly={true}
                                            />
                                          </td>
                                          <td>
                                            <button
                                              className="btn btn-primary btn-sm"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                handleAddProductClick();
                                              }}
                                            >
                                              Add
                                            </button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>

                                  <hr className="mt-3" />

                                  {/* {formData &&
                                    formData.items &&
                                    formData.items.length > 0 && (
                                      <>
                                        <div className="table-responsive  mt-1">
                                          <table className="table select-table itemtb">
                                            <thead>
                                              <tr>
                                                <th style={{ width: "15%" }}>
                                                  Product
                                                </th>
                                                <th>Quantity</th>
                                                <th>Price</th>
                                                <th>Base Price</th>
                                                <th>Discount</th>
                                                <th>Net Taxable</th>
                                                <th>Net Taxable Value</th>
                                                <th>Tax</th>
                                                <th style={{ width: "9%" }}>
                                                  Tax amount
                                                </th>
                                                <th>Amount</th>
                                                <th>&nbsp;</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {formData &&
                                                formData.items &&
                                                formData.items.map(
                                                  (item, index) => (
                                                    <tr key={index}>
                                                      <td>
                                                        {item.productName}
                                                      </td>
                                                      <td>{item.quantity}</td>
                                                      <td>
                                                        Rs{" "}
                                                        {parseFloat(
                                                          item.purchasePrice
                                                        ).toFixed(2)}
                                                      </td>
                                                      <td>
                                                        Rs{" "}
                                                        {parseFloat(
                                                          item.basePrice
                                                        ).toFixed(2)}
                                                      </td>
                                                      <td>
                                                        Rs{" "}
                                                        {parseFloat(
                                                          item.discount
                                                        ).toFixed(2)}
                                                      </td>
                                                      <td>
                                                        Rs{" "}
                                                        {parseFloat(
                                                          item.taxable
                                                        ).toFixed(2)}
                                                      </td>
                                                      <td>
                                                        Rs{" "}
                                                        {parseFloat(
                                                          item.taxableValue
                                                        ).toFixed(2)}
                                                      </td>
                                                      <td>{item.tax}%</td>
                                                      <td>
                                                        Rs{" "}
                                                        {parseFloat(
                                                          item.taxAmount
                                                        ).toFixed(2)}
                                                      </td>
                                                      <td>
                                                        Rs{" "}
                                                        {parseFloat(
                                                          item.amount
                                                        ).toFixed(2)}
                                                      </td>
                                                      <td>
                                                        <i
                                                          className="fs-20 mdi mdi-archive text-danger"
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            handleDelete(index);
                                                          }}
                                                        ></i>
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                            </tbody>
                                            <tfoot id="">
                                              <tr>
                                                <td colSpan="8"></td>
                                                <td>
                                                  <b>Subtotal</b>
                                                </td>
                                                <td colSpan="2">
                                                  <b>
                                                    Rs{" "}
                                                    {parseFloat(
                                                      formData.subtotal
                                                    ).toFixed(2)}
                                                  </b>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td colSpan="8"></td>
                                                <td>
                                                  <b>Tax(GST)</b>
                                                </td>
                                                <td colSpan="2">
                                                  <b>
                                                    Rs{" "}
                                                    {parseFloat(
                                                      formData.tax
                                                    ).toFixed(2)}
                                                  </b>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td colSpan="8"></td>
                                                <td>
                                                  <b>Total</b>
                                                </td>
                                                <td colSpan="2">
                                                  <b>
                                                    Rs{" "}
                                                    {parseFloat(
                                                      formData.total
                                                    ).toFixed(2)}
                                                  </b>
                                                </td>
                                              </tr>
                                            </tfoot>
                                          </table>
                                        </div>
                                      </>
                                    )} */}

                                  {formData &&
                                    formData.items &&
                                    formData.items.length > 0 && (
                                      <>
                                        <div className="table-responsive  mt-1">
                                          <table className="table select-table itemtb">
                                            <thead>
                                              <tr>
                                                <th>Ingredients</th>
                                                <th>Price</th>
                                                <th>Quantity</th>
                                                <th>Expiry Date</th>
                                                <th>Amount</th>
                                                <th>&nbsp;</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {formData &&
                                                formData.items &&
                                                formData.items.map(
                                                  (item, index) => (
                                                    <tr key={index}>
                                                      <td>
                                                        {item.productName}
                                                      </td>
                                                      <td>
                                                        Rs{" "}
                                                        {parseFloat(
                                                          item.purchasePrice
                                                        ).toFixed(2)}
                                                      </td>
                                                      <td>{item.quantity}</td>
                                                      <td>
                                                        {convertDateFormat(
                                                          item.expiryDate
                                                        )}
                                                      </td>
                                                      <td>
                                                        Rs{" "}
                                                        {parseFloat(
                                                          item.amount
                                                        ).toFixed(2)}
                                                      </td>
                                                      <td>
                                                        <i
                                                          className="fs-20 mdi mdi-archive text-danger"
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            handleDelete(index);
                                                          }}
                                                        ></i>
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                            </tbody>
                                            <tfoot id="">
                                              <tr>
                                                <td colSpan="3"></td>
                                                <td>
                                                  <b>Total</b>
                                                </td>
                                                <td colSpan="2">
                                                  <b>
                                                    Rs{" "}
                                                    {parseFloat(
                                                      formData.total
                                                    ).toFixed(2)}
                                                  </b>
                                                </td>
                                              </tr>
                                            </tfoot>
                                          </table>
                                        </div>
                                      </>
                                    )}
                                </div>

                                <div className="mt-3">
                                  <button
                                    type="submit"
                                    className="btn btn-primary me-2"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleCreateInvoice();
                                    }}
                                  >
                                    Submit
                                  </button>
                                  <button
                                    className="btn btn btn-secondary"
                                    onClick={handleBackClick}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <LoadingModal isLoading={isLoading} />

          <Notification />
        </>
      )}
    </>
  );
};

export default CreatePurchase;
